export default __webpack_public_path__ + "static/media/landscaping-2.b6f3d8f6.webp";